import { Link } from 'react-router-dom';
import MailingListButton from '../MailingListButton';
import '../../App.css';

function MailingList() {
  return (
      <div className="mailing-list-container">
        <h2>Stay in touch with Ms. Allison to get information about scheduling availability and upcoming events!</h2>
        <nav className="mailing-list-button-container">
          <Link to="/mailing-list">
            <MailingListButton />
          </Link>
        </nav>
    </div>
  )
}

export default MailingList;